import { render, staticRenderFns } from "./OwnVehiclesTable.vue?vue&type=template&id=13e84710"
import script from "./OwnVehiclesTable.vue?vue&type=script&lang=js"
export * from "./OwnVehiclesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports